import { render, staticRenderFns } from "./TheLayoutFab.vue?vue&type=template&id=709c8c38"
import script from "./TheLayoutFab.vue?vue&type=script&lang=js"
export * from "./TheLayoutFab.vue?vue&type=script&lang=js"
import style0 from "./TheLayoutFab.vue?vue&type=style&index=0&id=709c8c38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports